<template>
    <div class="home" :style="[backgroundImage,backgroundColor]">

        <div class="banner" v-if="app.banner">

            <img :src="app.banner" alt="">
        </div>

        <div class="menu-list" v-if="app.menus && app.menus.length">
            <div v-for="(item,index) in app.menus" :key="index" class="menu-item" @click="handleDetail(item,index)">
                <div class="icon">
                    <img :src="item.icon" alt="">
                </div>
                <span>{{item.name}}</span>

            </div>

        </div>

        <!-- <div class="address" @click="getLocation">
            北京维景国际大酒店
            <svg-icon icon-class="arrow-right" style="color:#999;"></svg-icon>
        </div> -->

        <div class="box" v-if="app.sign && app.sign.length > 0" :style="{'flex-direction': app.dir}">
            <div class="box-item" :style="{marginTop:item.top + 'px'}" v-for="item in app.sign" @click="handleDetail(item)">
                <span>{{item.name}}</span>
                <img :src="item.icon" alt="">
            </div>

        </div>

        <div class="img-list " v-if="app.history">
            <div class="img-title" v-if="app.history.title">{{app.history.title}}</div>
            <div class="imgs ql-snow">
                <div class="img-item ql-editor" v-html="app.history.content">

                </div>
            </div>
        </div>

        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">

            <van-swipe-item> <img src="http://tt.itnascn.com/uploads/20240428/B90B89B594A2C40F.jpg" alt=""></van-swipe-item>
            <van-swipe-item> <img src="http://tt.itnascn.com/uploads/20240428/B90B89B594A2C40F.jpg" alt=""></van-swipe-item>
            <van-swipe-item> <img src="http://tt.itnascn.com/uploads/20240428/B90B89B594A2C40F.jpg" alt=""></van-swipe-item>
            <template #indicator>
                <div></div>
            </template>
        </van-swipe>

        <div @click="submit" class="submit_btn">
            <p>一键获取报价</p>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { mapGetters } from 'vuex';
import httpRequest from '@/module_visitor/api/http.js';
import Banner from '@/components/Common/banner';
import wx from 'weixin-js-sdk';
import { getUrlCode } from '@/utils/index';
import { Toast } from 'vant';
export default {
    name: 'home',
    data() {
        return {
            app: {
                backdrop: '',
                primaryBg: '#fff',
            },
            localIn1fo: '',
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
        backgroundImage() {
            return this.app.backdrop ? { backgroundImage: 'url(' + this.app.backdrop + ')' } : null;
        },
        backgroundColor() {
            return this.app.primaryBg ? { backgroundColor: this.app.primaryBg } : null;
        },
    },
    components: { Banner },
    created() {
        this.getUserInfo();
    },
    mounted() {
        this.getJsApiTicket();
        this.handleData();
    },
    methods: {
        getWxUrlCode() {
            // 截取url中的code方法
            var url = location.search;
            var theRequest = new Object();
            if (url.indexOf('?') != -1) {
                var str = url.substr(1);
                var strs = str.split('&');
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
                }
            }
            return theRequest;
        },

        getCode() {
            // 非静默授权，第一次有弹框
            this.wxcode = '';
            var local = window.location.href; // 获取页面url
            var appid = 'wx1ce3f05b6999b325';
            let scope = 'snsapi_userinfo';
            this.wxcode = this.getWxUrlCode().code; // 截取code

            if (this.wxcode == null || this.wxcode === '') {
                // 如果没有code，则去请求
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
                    local,
                )}&response_type=code&scope=${scope}&state=123#wechat_redirect`;
            } else {
                // 你自己的业务逻辑
            }
        },

        getUserInfo() {
            var wxcode = this.getWxUrlCode().code; // 截取code

            if (wxcode) {
                httpRequest
                    .get(`/wechat/GetUserInfo`, {
                        code: wxcode,
                    })
                    .then(res => {
                        const { code, data } = res.data;
                        if (code == 200) {
                            Toast.success('您的报价申请已提交成功，我们将在第一时间与您联系！');
                        } else {
                            Toast.success('您的已提交！');
                        }
                    });
            }
        },

        submit() {
            this.getCode();
        },

        // 微信分参数

        handleData() {
            const { acid } = getUrlCode();
            httpRequest.get(`/api/ConfigPage/Module?module=home`).then(res => {
                const { code, data } = res.data;

                if (code == 200) {
                    var pageInfo = data.find(it => it.moudle == 'home');

                    this.app = JSON.parse(pageInfo.pageData);
                }
            });

            httpRequest.get(`/api/TActivity/Info`).then(res => {
                const { code, data } = res.data;

                if (code == 200) {
                    this.localInfo = JSON.parse(data.address);
                }
            });
        },
        getJsApiTicket() {
            let url = location.href.split('#')[0]; //获取锚点之前的链接

            httpRequest
                .get(`/api/visitor/GetJsApiTicket`, {
                    url: url,
                })
                .then(res => {
                    const { data, code, msg } = res.data;
                    if (code == 200) {
                        this.wxinit(data);
                    }
                });
        },
        wxinit(res) {
            wx.config({
                debug: false,
                appId: res.appId,
                timestamp: parseInt(res.timestamp),
                nonceStr: res.nonceStr,
                signature: res.signature,
                jsApiList: [
                    'checkJsApi',
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'onMenuShareAppMessage',
                    'openLocation',
                    'getLocation',
                ],
            });
        },
        getLocation() {
            var local = this.localInfo;
            if (!local) {
                Toast('定位未配置，请联系工作人员');
                return;
            }
            wx.openLocation({
                latitude: local.latlng.lat, // 纬度，浮点数，范围为90 ~ -90
                longitude: local.latlng.lng, // 经度，浮点数，范围为180 ~ -180。
                name: local.poiname, // 位置名
                address: local.poiaddress, // 地址详情说明
                scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
                infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
            });
        },

        handleDetail(item) {
            console.log(item.link.replace('/', ''));

            if (item.link.replace('/', '') == 'local') {
                this.getLocation();
                return;
            }

            if (item.link.replace('/', '') == 'login' || item.link.replace('/', '') == 'register') {
                this.$router.push({
                    path: item.link,
                    query: {
                        source: this.$route.query.source,
                        companyId: this.$route.query.companyId,
                        teamId: this.$route.query.teamId,
                    },
                });
                return;
            }

            {
                if (item.link.indexOf('http') > -1) {
                    window.location.href = item.link;
                } else {
                    this.$router.push({
                        path: item.link,
                        query: {
                            item: item,
                        },
                    });
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@keyframes scaleAnimation {
    0%,
    30%,
    100% {
        /* 快速回到原大小，在动画开始、30%和结束时 */
        transform: scale(1);
    }
    60% {
        /* 较晚时刻放大，留出更多时间返回原大小 */
        transform: scale(1.1);
    }
    80% {
        /* 较晚时刻放大，留出更多时间返回原大小 */
        transform: scale(1.2);
    }
}
.home {
    font-size: 14px;
    height: 100vh;
    overflow-y: scroll;
    background-size: cover;
    box-sizing: border-box;
    padding-bottom: 100px;
    .banner {
        img {
            width: 100%;
        }
    }
    .menu-list {
        display: flex;
        padding: 12px 8px;
        .menu-item {
            width: 25%;
            display: flex;
            align-items: center;
            flex-direction: column;
            .icon {
                width: 50px;
                height: 50px;

                border-radius: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    width: 50px;
                    height: 50px;
                }
            }
            span {
                margin-top: 8px;
            }
        }
    }
    .address {
        background: #eaeaea;
        margin: 0 18px;
        padding: 8px;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
    }
    .box {
        // display: flex;
        // justify-content: space-between;
        display: flex;
        padding: 8px;
        .box-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex: 1;
            border-radius: 8px;
            position: relative;

            span {
                font-size: 16px;
                color: #fff;
                position: absolute;
                left: 10px;
                top: 20px;
                z-index: 1;
            }
            img {
                width: 100%;
                height: auto;
            }
        }
        .box-item {
            span {
            }
        }
    }
    .my-swipe {
        width: 100%;
        img {
            width: 100%;
        }
    }
    .submit_btn {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 80px;
        border-top: 1px solid #f8f8f8;
        background: #fff;
        p {
            animation: scaleAnimation 1s ease-in-out infinite;
            background: #327af6;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #fff;
            padding: 0 12px;
            border-radius: 4px;
        }
    }
    .img-list {
        .img-title {
            font-weight: bold;
            font-size: 18px;
            padding: 4px 18px;
            position: relative;
            &::after {
                position: absolute;
                left: 10px;
                border-radius: 4px;
                top: 50%;
                transform: translateY(-50%);
                content: '';
                width: 4px;
                height: 60%;
                background: #327af6;
            }
        }
        .imgs {
            .img-item {
                ::v-deep img {
                    width: 100%;
                }
            }
            .ql-editor {
            }
        }
        .ql-snow {
        }
    }
}
</style>